// PayHub brand mark.
//
// Renders the wallet/arrow logomark as a PNG image. Two presentation modes
// share the same icon-only artwork:
//   • `<Logo>`     — icon-only mark (no wordmark) for hero, login, app shell.
//   • `<Wordmark>` — icon + the "PayHub" text for navigation rails.
//
// The bicolour brand identity (orange wallet on dark) is intentional — we
// don't tint via currentColor so a stray text-foreground can't recolour the
// mark.

import { cn } from '@/lib/utils';

type Size = 'sm' | 'md' | 'lg' | 'xl';

const SIZE: Record<Size, string> = {
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
};

const VERIFY = '#F39200';

export function Logo({ size = 'md', className }: { size?: Size; className?: string }) {
  return (
    <img
      src="/payhub-mark.png"
      alt="PayHub"
      width={256}
      height={147}
      decoding="async"
      draggable={false}
      className={cn(SIZE[size], 'shrink-0 object-contain', className)}
    />
  );
}

export function Wordmark({
  size = 'md',
  className,
}: {
  size?: Size;
  className?: string;
}) {
  const text = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-2xl',
  }[size];
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <Logo size={size} />
      <span className={cn('font-semibold tracking-tight', text)}>
        Pay<span style={{ color: VERIFY }}>Hub</span>
      </span>
    </span>
  );
}
